import { createWebCanvasHost } from './web-canvas-host.js'

let host = null
export function getWebCanvasHost() { return (host ||= createWebCanvasHost()) }
